import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import "../../style/pages.css";
import "./Home.css";

export default function Home() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.getDashboard().then(setData).catch((reason) => setError(reason.message));
  }, []);

  if (error) return <div className="error-state">상황 데이터를 수신하지 못했습니다: {error}</div>;
  if (!data) return <div className="empty-state">상황실 데이터 동기화 중...</div>;

  return (
    <div>
      <header className="page-head">
        <div><p className="eyebrow">OPERATIONS / NODE GB-33-A</p><h1>생존 상황실</h1></div>
        <p>전체 네트워크의 마지막 동기화 자료입니다. 정보 지연과 일부 기록 손상이 발생할 수 있습니다.</p>
      </header>
      <section className="emergency-strip"><span>긴급</span><strong>북동쪽 방벽 경계 단계 3 발령</strong><p>비전투 인원은 04:00까지 지하 대피 구역으로 이동하십시오.</p></section>
      <section className="stat-grid" aria-label="핵심 생존 지표">
        {data.stats.map((item) => <article className={`stat-card tone-${item.tone}`} key={item.label}><span>{item.label}</span><div><strong>{item.value}</strong><small>{item.unit}</small></div><p>{item.delta}</p></article>)}
      </section>
      <div className="dashboard-grid">
        <section>
          <div className="section-title"><h2>실시간 경보</h2><span>LIVE FEED</span></div>
          <div className="alert-list panel">
            {data.alerts.map((alert) => <article key={alert.id} className={`alert-row ${alert.level.toLowerCase()}`}><div className="alert-code">{alert.level.slice(0, 3)}</div><div><div className="alert-meta"><span>{alert.area}</span><time>{alert.createdAt}</time></div><h3>{alert.title}</h3><p>{alert.message}</p></div></article>)}
          </div>
        </section>
        <aside>
          <div className="section-title"><h2>망 상태</h2><span>NETWORK</span></div>
          <div className="network-card panel"><div className="radar"><i /><span>07</span></div><dl><div><dt>연결 상태</dt><dd>{data.network.status}</dd></div><div><dt>응답 지연</dt><dd>{data.network.latency}</dd></div><div><dt>활성 노드</dt><dd>{data.network.activeNodes} / 12</dd></div><div><dt>최종 동기화</dt><dd>{data.network.lastSyncAt}</dd></div></dl></div>
        </aside>
      </div>
      <div className="section-title"><h2>최근 네트워크 기록</h2><Link to="/board">게시판 전체 보기 →</Link></div>
      <section className="news-grid">
        {data.news.map((item) => <Link to={`/news/${item.id}`} className="news-card panel" key={item.id}><div><span>{item.category}</span><time>{item.createdAt}</time></div><h3>{item.title}</h3><p>{item.summary}</p><small>{item.author} / 기록 열람 →</small></Link>)}
      </section>
    </div>
  );
}
